(function(){
  var TIERS = [{
    cents: 50000,
    emoji: '🚚',
    zh: '免運費',
    en: 'FREE SHIPPING'
  }];
  var MAX = 50000;
  var CUR = '$';

  function isZh(el) {
    var loc = (el.dataset.locale || '').toLowerCase();
    return loc.indexOf('zh') !== -1;
  }

  function render(el) {
    var MAX = parseInt(el.dataset.threshold, 10) || 50000;
    var CUR = el.dataset.currency || '$';
    var TIERS = [{ cents: MAX, emoji: '🚚', zh: '免運費', en: 'FREE SHIPPING' }];
    var cents = parseInt(el.dataset.cents, 10) || 0;
    var fill  = el.querySelector('.gcpb__fill');
    var msg   = el.querySelector('.gcpb__msg');
    var dots  = el.querySelectorAll('.gcpb__dot');
    var items = el.querySelectorAll('.gcpb__list li');
    var zh    = isZh(el);
    if (!fill || !msg) return;

    fill.style.transform = 'scaleX(' + Math.min(cents / MAX, 1).toFixed(4) + ')';

    var next = null;
    TIERS.forEach(function(t, i) {
      var ok = cents >= t.cents;
      if (dots[i])  dots[i].classList.toggle('gcpb--reached', ok);
      if (items[i]) items[i].classList.toggle('gcpb--reached', ok);
      if (!ok && !next) next = t;
    });

    if (next) {
      var diff = Math.ceil((next.cents - cents) / 100);
      if (zh) {
        msg.textContent = '再消費 ' + CUR + diff + ' 即享 ' + next.emoji + ' ' + next.zh + '!';
      } else {
        msg.textContent = 'SPEND ' + CUR + diff + ' MORE FOR ' + next.emoji + ' ' + next.en + '!';
      }
    } else {
      msg.textContent = zh
        ? '🎉 免運費已解鎖！'
        : '🎉 FREE SHIPPING UNLOCKED!';
    }
  }

  function update() {
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c) {
      document.querySelectorAll('.gcpb').forEach(function(el) {
        el.dataset.cents = c.total_price;
        render(el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }

  var obs = new MutationObserver(function(ms) {
    var found = false;
    ms.forEach(function(m) {
      m.addedNodes.forEach(function(n) {
        if (n.nodeType !== 1) return;
        if ((n.classList && n.classList.contains('gcpb')) ||
            (n.querySelector && n.querySelector('.gcpb'))) found = true;
      });
    });
    if (found) update();
  });
  obs.observe(document.body, { childList: true, subtree: true });
  document.addEventListener('cart:refresh', update);
})();